"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.VerticalSpacing = exports.SpaceWrapper = exports.SpacerStyle = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _rebass = require("rebass");

var SpacerStyle = (0, _styled.default)('div')(function (_ref) {
  var spacing = _ref.theme.spacing;
  return _objectSpread({}, spacing.wrapperStyle);
});
exports.SpacerStyle = SpacerStyle;
var SpaceWrapper = (0, _styled.default)(_rebass.Box)(function (_ref2) {
  var spacing = _ref2.theme.spacing;
  return _objectSpread(_objectSpread({}, spacing.childStyle), {}, {
    width: '100%'
  });
});
exports.SpaceWrapper = SpaceWrapper;
var VerticalSpacing = (0, _styled.default)(_rebass.Box)(function (_ref3) {
  var spacing = _ref3.spacing,
      space = _ref3.theme.space;
  return {
    paddingTop: space[spacing],
    paddingBottom: space[spacing]
  };
});
exports.VerticalSpacing = VerticalSpacing;
var _default = SpaceWrapper;
exports.default = _default;